module.exports = __webpack_public_path__ + "img/herotext.a31a9973.png";